/**
 * SectionGroup で有効化可能な機能属性
 * サーバーから返される functionAttributes の値
 */
export const FEATURE_ATTRIBUTES = [
  // Web ルート保護対象
  'RecordList',
  'Video',
  'UserData',
  'Dialog',
  'GOST',
  'TOMASS',
  'TOMASS_SUM',
  // スマホアプリ用（Web ガード不要）
  'STETHOSCOPE',
  'SSTPLUS',
  'SST',
  'MONITORING',
  'VS',
  'RSST',
  'MWST',
  'FOOD',
  'PCT',
  'GUIDE_POSTURE',
  'NB4CONFIG',
  '_PROT_GUIDE_POSTURE',
] as const;

export type FeatureAttribute = (typeof FEATURE_ATTRIBUTES)[number];

/** Web ルートガードの対象となる機能 */
export const WEB_PROTECTED_FEATURES: readonly FeatureAttribute[] = [
  'Dialog',
  'TOMASS_SUM',
  'TOMASS',
  'UserData',
  'Video',
  'GOST',
];

/** 指定された値が FeatureAttribute かどうかを判定 */
export function isFeatureAttribute(value: unknown): value is FeatureAttribute {
  return (
    typeof value === 'string' &&
    FEATURE_ATTRIBUTES.includes(value as FeatureAttribute)
  );
}
